import React, { useState } from 'react';

const QuickPartSelector = ({ parts, onSubmit, onCancel, loading }) => {
  const [selectedPart, setSelectedPart] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!selectedPart) newErrors.selectedPart = 'Veuillez sélectionner une pièce';
    if (!quantity || quantity < 1) newErrors.quantity = 'La quantité doit être supérieure à 0';
    if (selectedPart && quantity) {
      const part = parts.find(p => p.id === selectedPart);
      if (part && quantity > part.stock_quantity) newErrors.quantity = `Stock insuffisant (${part.stock_quantity} disponibles)`;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const part = parts.find(p => p.id === selectedPart);
      if (part) {
        const partItem = {
          type: 'part',
          part_id: part.id,
          service_id: '',
          description: `${part.name} (Réf: ${part.reference})`,
          quantity: quantity,
          unit_price: part.selling_price || 0,
          total: quantity * (part.selling_price || 0),
          tax_rate: 20
        };
        onSubmit(partItem);
      }
    }
  };

  const selectedPartData = parts.find(p => p.id === selectedPart);

  return (
    <div className="modal-overlay">
      <div className="modal-content quick-part-selector">
        <div className="modal-header">
          <h3>Ajouter un produit</h3>
          <button type="button" className="close-btn" onClick={onCancel}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="quick-part-form">
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="part">Produit *</label>
              <select id="part" value={selectedPart} onChange={(e) => setSelectedPart(e.target.value)} className={errors.selectedPart ? 'error' : ''}>
                <option value="">Sélectionner un produit...</option>
                {parts.filter(p => p.stock_quantity > 0).map(part => (
                  <option key={part.id} value={part.id}>{part.name} - {part.selling_price}€ (Stock: {part.stock_quantity})</option>
                ))}
              </select>
              {errors.selectedPart && <span className="error-text">{errors.selectedPart}</span>}
            </div>

            {selectedPartData && (
              <div className="part-details">
                <div className="detail-item"><strong>Référence:</strong> {selectedPartData.reference}</div>
                <div className="detail-item"><strong>Catégorie:</strong> {selectedPartData.category}</div>
                <div className="detail-item"><strong>Prix unitaire:</strong> {selectedPartData.selling_price}€</div>
                <div className="detail-item"><strong>Stock disponible:</strong> {selectedPartData.stock_quantity}</div>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="quantity">Quantité *</label>
              <input type="number" id="quantity" value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value) || 0)} min="1" max={selectedPartData?.stock_quantity || 999} className={errors.quantity ? 'error' : ''} />
              {errors.quantity && <span className="error-text">{errors.quantity}</span>}
            </div>

            {selectedPartData && (
              <div className="total-preview">
                <strong>Total: {(quantity * (selectedPartData.selling_price || 0)).toFixed(2)}€</strong>
              </div>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">Annuler</button>
            <button type="submit" disabled={loading} className="btn-primary">{loading ? 'Ajout...' : 'Ajouter le produit'}</button>
          </div>
        </form>

        <style>{`
          .quick-part-selector { background: var(--admin-panel); color: var(--admin-text); border: 1px solid var(--admin-border); border-radius: 12px; }
          .quick-part-selector .modal-header { display: flex; justify-content: space-between; align-items: center; padding: 20px 20px 0 20px; border-bottom: 1px solid var(--admin-border); margin-bottom: 16px; }
          .quick-part-form { padding: 20px; }
          .quick-part-form .form-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px,1fr)); gap: 16px; margin-bottom: 12px; }
          .quick-part-form .form-group { display: flex; flex-direction: column; gap: 6px; }
          .quick-part-form .form-group label { font-weight: 500; color: var(--admin-text); font-size: .9rem; }
          .quick-part-form .form-group input, .quick-part-form .form-group select { padding: 12px; border: 1px solid var(--admin-border); background: var(--admin-panel-2); color: var(--admin-text); border-radius: 8px; font-size: .9rem; }
          .quick-part-form .form-group input:focus, .quick-part-form .form-group select:focus { outline: none; border-color: var(--admin-accent); box-shadow: 0 0 0 3px rgba(79,70,229,0.20); }
          .quick-part-form .form-group .error-text { color: #ef4444; font-size: .8rem; }
          .quick-part-selector .modal-actions { display: flex; justify-content: flex-end; gap: 12px; padding: 0 20px 20px 20px; border-top: 1px solid var(--admin-border); margin-top: 12px; padding-top: 16px; }
          .quick-part-selector .part-details, .quick-part-selector .total-preview { padding: 12px; border: 1px solid var(--admin-border); border-radius: 8px; background: var(--admin-panel-2); }
          .quick-part-selector .detail-item { font-size: .85rem; color: var(--admin-text); }
        `}</style>
      </div>
    </div>
  );
};

export default QuickPartSelector;
